<mat-nav-list class="sidebar-nav">
  <!-- Fixed Header -->
  <div class="sidebar-header">
    <a mat-list-item [routerLink]="'./'" class="sidebar-logo-item">
      <img matListItemAvatar src="/assets/images/logo.png" alt="Logo" class="sidebar-logo">
      <span matListItemTitle class="logo-title">XSURE DIGITAL</span>
      <span matListItemLine class="logo-subtitle">UMOJA PLATFORM</span>
    </a>
    <mat-divider/>
  </div>

  <!-- Scrollable Menu -->
  <div class="sidebar-menu">
    @for (group of newNavGroups; track group.label) {
      <div class="py-3">
        <div class="px-[18px] pb-[6px] group-header">{{ group.label }}</div>

        @for (item of group.children; track item.label) {
          @if (item.children?.length) {
            <a mat-list-item class="sidebar-item sidebar-parent"
               [class.active-link]="!isExpanded(item.label) && hasActiveChild(item)"
               (click)="toggleItem(item.label)">
              @if (item.icon; as icon) {
                <mat-icon matListItemIcon [svgIcon]="icon"></mat-icon>
              } @else if (item.color; as color) {
                <div matListItemIcon class="flex flex-col justify-center items-center">
                  <div class="w-2 aspect-square rounded-full" [class]="'sidebar-user-item--' + color"></div>
                </div>
              }
              <span matListItemTitle>{{ item.label }}</span>
              <mat-icon matListItemMeta class="chevron-icon" [class.chevron-icon--open]="isExpanded(item.label)" svgIcon="icon-chevron-down"/>
            </a>
            <div class="submenu" [class.submenu--open]="isExpanded(item.label)">
              @for (child of item.children; track child.label) {
                <ng-container *ngTemplateOutlet="sideBarItem; context: {item: child, isChild: true}"/>
              }
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="sideBarItem; context: {item: item, isChild: false}"/>
          }
        }
      </div>
      <mat-divider/>
    }
  </div>

  <!-- Fixed Footer -->
  <div class="sidebar-footer">
    <mat-divider/>
    <a mat-list-item [routerLink]="dashboardItem.route" class="sidebar-user-item">
      <div matListItemAvatar class="sidebar-user-item__avatar">
        {{ auth.initials() }}
      </div>
      <span matListItemTitle class="sidebar-user-item__title">{{ auth.fullName() }}</span>
      <span matListItemLine class="sidebar-user-item__subtitle">{{ auth.profileTitle() }}</span>

      <div matListItemMeta class="sidebar-user-item__action-container">
        <button mat-icon-button (click)="logout()" class="sidebar-user-item__action">
          <mat-icon svgIcon="icon-logout"></mat-icon>
        </button>
      </div>
    </a>
  </div>
</mat-nav-list>


<ng-template #sideBarItem  let-item="item" let-isChild="isChild" >
  <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: false}" [class.sidebar-item--child]="isChild" class="sidebar-item" (click)="!isChild && collapseAll(); isMobile() && close.emit()">
    @if (item.icon; as icon) {
      <mat-icon matListItemIcon [svgIcon]="icon"></mat-icon>
    } @else if (item.color; as color) {
      <div matListItemIcon class="flex flex-col justify-center items-center">
        <div class="w-2 aspect-square rounded-full bg-white"
             [class]="'sidebar-user-item--' + color">
        </div>
      </div>
    }
    <span matListItemTitle>{{ item.label }}</span>

    @if (item.route === '/comesa/reference-data/exchange-rates' && hasNoRateForToday()) {
      <span matListItemMeta class="fx-alert" matTooltip="No exchange rate captured for today" title="No exchange rate captured for today">
        <mat-icon svgIcon="alert"></mat-icon>
      </span>
    }

    @if (item.count; as count) {
      <span matListItemMeta class="claims-badge">{{ count }}</span>
    }
  </a>
</ng-template>
